import React, { useState, useEffect } from 'react';
import './TestimonialsCarousel.css';

interface Testimonial {
  id: string;
  name: string;
  text: string;
  rating: number;
}

const TestimonialsCarousel: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Select the 4 best/most impactful reviews for the carousel
  const testimonials: Testimonial[] = [
    {
      id: '1',
      name: 'Su S K',
      text: 'Emmanuel Ibenye, Lawyer/ Notary Public, provided outstanding service today. He handled the signing of our documents with efficiency, accuracy, and professionalism. I highly recommend his services to anyone in need of reliable legal or notary assistance.',
      rating: 5
    },
    {
      id: '2',
      name: 'Umar Khan',
      text: 'Emmanuel helped me notarize a legal document and was incredibly helpful throughout the process. He provided valuable insight and answered all my questions. He was kind, understanding, and took his time to ensure everything went smoothly. Highly recommend his services!',
      rating: 5
    },
    {
      id: '3',
      name: 'Harpreet Kaur Dhaliwal',
      text: 'I went to get something notarized at around 11pm, I was very hesitant at first as Emmanuel works from home and because of the time of the day too. But he was extremely polite, kind accommodating and very helpful.',
      rating: 5
    },
    {
      id: '4',
      name: 'Jenn and Rj',
      text: 'Very responsive, great communication and available. I called at 10pm and everything notarized by 10:30pm',
      rating: 5
    }
  ];

  // Auto-advance carousel every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(timer);
  }, [testimonials.length]);

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span key={index} className={`star ${index < rating ? 'filled' : ''}`}>
        ★
      </span>
    ));
  };

  return (
    <section id="testimonials" className="testimonials-carousel-section">
      <div className="container">
        <div className="testimonials-header">
          <h2>What Our Clients Say</h2>
          <p>Trusted by hundreds of satisfied clients across Ontario</p>
        </div>

        <div className="carousel-container">
          <div className="testimonial-card">
            <div className="quote-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h4v10h-10z"/>
              </svg>
            </div>
            
            <div className="testimonial-content">
              <div className="testimonial-rating">
                {renderStars(testimonials[currentIndex].rating)}
              </div>
              
              <p className="testimonial-text">"{testimonials[currentIndex].text}"</p>
              
              <div className="testimonial-author">
                <div className="author-info">
                  <h4>{testimonials[currentIndex].name}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="carousel-controls">
          <div className="carousel-dots">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>

        <div className="testimonials-footer">
          <a href="/reviews" className="view-all-link">
            View All Reviews
          </a>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsCarousel;